import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import api from '@/axios';
import { GET_LOT_SIZING_KEY } from '@/keys';
import type { LotSizing } from '@/types/core/lot-sizing/lot-sizing';

export const getLotSizing = async (id: string): Promise<LotSizing> => {
  const response = await api.get<LotSizing>(`/lot-sizings/${id}`);
  return response.data;
};

export const useGetLotSizing = (
  id: string,
): UseSuspenseQueryResult<LotSizing, Error> =>
  useSuspenseQuery({
    queryKey: [...GET_LOT_SIZING_KEY, id],
    queryFn: () => getLotSizing(id),
    staleTime: 0,
  });
